<template>
  <!-- Main skeleton placeholder -->
  <Skeletor v-if="loading.main" :height="35" width="'40%'" data-qa="step3-skeleton-main" />

  <!-- Delivery types loading skeleton -->
  <div v-if="loading.main || loading.deliveryTypes" data-qa="step3-skeleton-types">
    <div class="w-full grid grid-cols-3 mt-4 gap-4 xl:w-10/12">
      <div
        class="flex flex-col justify-center skeleton-container px-8 py-6 border-2"
        v-for="i in 3"
        :key="i"
      >
        <Skeletor flex :height="15" :width="'50%'" />
        <Skeletor flex class="mt-3" :height="10" :width="'25%'" />
        <Skeletor flex class="mt-2" :height="10" :width="'50%'" />
      </div>
    </div>
    <div class="flex flex-col mt-6 pb-6">
      <Skeletor :height="20" :width="'30%'" />
      <div class="flex mt-2">
        <div class="flex">
          <Skeletor :height="15" :width="'15px'" />
          <Skeletor
            class="ml-3"
            :height="15"
            :width="$isMobile ? '100px' : '150px'"
          />
        </div>
        <div class="flex ml-10">
          <Skeletor :height="15" :width="'15px'" />
          <Skeletor
            class="ml-3"
            :height="15"
            :width="$isMobile ? '100px' : '150px'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { loading } = defineProps(['loading'])
</script>
